import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Per-route <title> and meta description.
 *
 * index.html carries a hand-written English set for crawlers that do not run
 * JavaScript — that is the floor, and it is the only thing a non-executing
 * crawler will ever see. This hook layers the translated, route-specific version
 * on top for browsers and for crawlers that do render.
 */
export const useSiteMeta = (titleKey: string, descriptionKey: string): void => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        const title = t(titleKey);
        document.title = title;

        const tag = document.querySelector('meta[name="description"]');
        if (tag) tag.setAttribute('content', t(descriptionKey));
        // i18n.language is in the deps because changing language has to retitle the
        // page; t itself is stable across a language change.
    }, [t, i18n.language, titleKey, descriptionKey]);
};
